import type { Currency } from '@ps/web-core-enums';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { select } from '../store';

export type FormatAsCurrency = (formatProps: FormatProps) => string;

interface FormatProps {
  value: number;
  cents?: boolean;
  currency?: Currency;
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
}

const useCurrencyFormatter = (): FormatAsCurrency => {
  const { formatNumber } = useIntl();
  const realMoneyCurrency = useSelector(select.currency.getRealMoney);

  const formatAsCurrency = useCallback(
    ({
      cents,
      value,
      currency = realMoneyCurrency,
      minimumFractionDigits = 2,
      maximumFractionDigits
    }: FormatProps) =>
      formatNumber(cents ? value / 100 : value, {
        currency,
        style: 'currency',
        minimumFractionDigits,
        maximumFractionDigits
      }),
    [formatNumber, realMoneyCurrency]
  );

  return formatAsCurrency;
};

export default useCurrencyFormatter;
